module.exports = __webpack_public_path__ + "static/media/26UNRWA26.5abeb841.jpg";